import React from 'react';
interface ButtonProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  children: React.ReactNode;
  href: string;
  className?: string;
}
export function Button({
  children,
  href,
  className = '',
  ...props
}: ButtonProps) {
  return <a href={href} className={`
        inline-flex items-center justify-center gap-2 
        bg-brand-gold text-navy font-extrabold text-base 
        py-[18px] px-9 rounded-xl w-full max-w-[420px] 
        transition-all duration-200 ease-out
        shadow-[0_0_30px_rgba(245,158,11,0.35)]
        hover:bg-brand-gold-light hover:-translate-y-0.5 hover:shadow-[0_0_45px_rgba(245,158,11,0.55)]
        tracking-[0.3px]
        ${className}
      `} {...props} data-id="element-43">
      {children}
    </a>;
}